/**
 * Factories container
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { actions } from './slice';
import {
  factoriesLoadingSelector,
  factorySelector,
  factoryUploadProgress,
} from './selectors';
import { userSelector } from '../User/selectors';
import promisifyActions from '../../Lib/Utils/promisify-actions';
import VendorFactory from '../../Components/VendorFactory/VendorFactory';
import { publicFilesUrlsSelector } from '../VendorApplication/selectors';

function VendorFactoryComponent(props) {
  return <VendorFactory {...props} />;
}

/**
 * Properties to be provided to the bill payment component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  factory: factorySelector(state),
  loading: factoriesLoadingSelector(state),
  publicFilesUrls: publicFilesUrlsSelector(state),
  uploadFileProgress: factoryUploadProgress(state),
  user: userSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch bill payment actions
 */
const mapDispatchToProps = (dispatch) => ({
  createFactory: (factory, userId) =>
    dispatch(actions.create({ userId, factory })),
  getFactory: (factoryId, userId) =>
    dispatch(actions.get({ userId, factoryId })),
  updateFactory: (updates, factoryId, userId) =>
    dispatch(actions.update({ updates, factoryId, userId })),
  updateFile: (file, signedUrl, fileName) =>
    dispatch(actions.updateFile({ file, signedUrl, fileName })),
});

/**
 * Connects state to the Vendor Factories component
 *
 * @param {object} mapStateToProps data object to become props for the Factories component
 * @param {object} mapDispatchToProps Factories actions to be dispatched to reducer
 */
export default withRouter(
  connect(
    mapStateToProps,
    promisifyActions(mapDispatchToProps),
  )(VendorFactoryComponent),
);
